import { FC } from 'react';

import SvgLib from 'components/SvgLib';
import RichText from 'components/RichText';

import { ITestimonialProps } from '../../models/Testimonial';
import ImageComponent from '../Image';
import Typo from '../Typo';
import styles from './testimonial.module.sass';

const TestimonialCard: FC<ITestimonialProps> = ({ person, content }) => {
  return (
    <div className={styles.testimonialCard}>
      <div className="is-flex is-flex-direction-column">
        <SvgLib icon="quote" classes={styles.quoteIcon} />
        <div className={styles.description}>
          <RichText classes={styles.descriptionText} document={content} />
        </div>
      </div>
      <div className={styles.testimonialPersonContainer}>
        {person.fields.avatar && (
          <ImageComponent
            classes={styles.testimonialPersonImage}
            image={person.fields.avatar}
            height="64"
            aspectRatio="1/1"
          />
        )}
        <div className={styles.testimonialPersonInfo}>
          <Typo limitLines={2} classes={`font-weight-bold is-size-3 ${styles.personTitle}`}>
            {person.fields.fullName}
          </Typo>
          <Typo limitLines={2} classes={`font-weight-bold is-size-3 ${styles.personSubtitle}`}>
            {person.fields.subTitle}
          </Typo>
        </div>
      </div>
    </div>
  );
};

export default TestimonialCard;
